import { ɵgetAllInstancesOf as _getAllInstancesOf, ɵgetDefaultInstanceOf as _getDefaultInstanceOf, VERSION, ɵAngularFireSchedulers as _AngularFireSchedulers, ɵzoneWrap as _zoneWrap } from '@angular/fire';
import { timer, from } from 'rxjs';
import { concatMap, distinct } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { InjectionToken, Optional, NgModule, makeEnvironmentProviders, NgZone, Injector } from '@angular/core';
import { FirebaseApp, FirebaseApps } from '@angular/fire/app';
import { AppCheckInstances } from '@angular/fire/app-check';
import { AuthInstances } from '@angular/fire/auth';
import { registerVersion } from 'firebase/app';
import { auditTrail as auditTrail$1, changeToData as changeToData$1, fromRef as fromRef$1, list as list$1, listVal as listVal$1, object as object$1, objectVal as objectVal$1, stateChanges as stateChanges$1 } from 'rxfire/database';
export { ListenEvent, ListenerMethods } from 'rxfire/database';
import { child as child$1, connectDatabaseEmulator as connectDatabaseEmulator$1, enableLogging as enableLogging$1, endAt as endAt$1, endBefore as endBefore$1, equalTo as equalTo$1, forceLongPolling as forceLongPolling$1, forceWebSockets as forceWebSockets$1, get as get$1, getDatabase as getDatabase$1, goOffline as goOffline$1, goOnline as goOnline$1, increment as increment$1, limitToFirst as limitToFirst$1, limitToLast as limitToLast$1, off as off$1, onChildAdded as onChildAdded$1, onChildChanged as onChildChanged$1, onChildMoved as onChildMoved$1, onChildRemoved as onChildRemoved$1, onDisconnect as onDisconnect$1, onValue as onValue$1, orderByChild as orderByChild$1, orderByKey as orderByKey$1, orderByPriority as orderByPriority$1, orderByValue as orderByValue$1, push as push$1, query as query$1, ref as ref$1, refFromURL as refFromURL$1, remove as remove$1, runTransaction as runTransaction$1, set as set$1, setPriority as setPriority$1, setWithPriority as setWithPriority$1, startAfter as startAfter$1, startAt as startAt$1, update as update$1 } from 'firebase/database';
export * from 'firebase/database';
class Database {
  constructor(database) {
    return database;
  }
}
const DATABASE_PROVIDER_NAME = 'database';
class DatabaseInstances {
  constructor() {
    return _getAllInstancesOf(DATABASE_PROVIDER_NAME);
  }
}
const databaseInstance$ = /*#__PURE__*/ /*#__PURE__*/timer(0, 300).pipe(/*#__PURE__*/concatMap(() => from(_getAllInstancesOf(DATABASE_PROVIDER_NAME))), /*#__PURE__*/distinct());
const PROVIDED_DATABASE_INSTANCES = /*#__PURE__*/new InjectionToken('angularfire2.database-instances');
function defaultDatabaseInstanceFactory(provided, defaultApp) {
  const defaultDatabase = _getDefaultInstanceOf(DATABASE_PROVIDER_NAME, provided, defaultApp);
  return defaultDatabase && new Database(defaultDatabase);
}
function databaseInstanceFactory(fn) {
  return (zone, injector) => {
    const database = zone.runOutsideAngular(() => fn(injector));
    return new Database(database);
  };
}
const DATABASE_INSTANCES_PROVIDER = {
  provide: DatabaseInstances,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_DATABASE_INSTANCES]]
};
const DEFAULT_DATABASE_INSTANCE_PROVIDER = {
  provide: Database,
  useFactory: defaultDatabaseInstanceFactory,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_DATABASE_INSTANCES], FirebaseApp]
};
let DatabaseModule = /*#__PURE__*/(() => {
  class DatabaseModule {
    constructor() {
      registerVersion('angularfire', VERSION.full, 'rtdb');
    }
    static ɵfac = function DatabaseModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DatabaseModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DatabaseModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [DEFAULT_DATABASE_INSTANCE_PROVIDER, DATABASE_INSTANCES_PROVIDER]
    });
  }
  return DatabaseModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideDatabase(fn, ...deps) {
  registerVersion('angularfire', VERSION.full, 'rtdb');
  return makeEnvironmentProviders([DEFAULT_DATABASE_INSTANCE_PROVIDER, DATABASE_INSTANCES_PROVIDER, {
    provide: PROVIDED_DATABASE_INSTANCES,
    useFactory: databaseInstanceFactory(fn),
    multi: true,
    deps: [NgZone, Injector, _AngularFireSchedulers, FirebaseApps,
    // Database+Auth work better if Auth is loaded first
    [new Optional(), AuthInstances], [new Optional(), AppCheckInstances], ...deps]
  }]);
}

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const auditTrail = /*#__PURE__*/_zoneWrap(auditTrail$1, true);
const changeToData = /*#__PURE__*/_zoneWrap(changeToData$1, true);
const fromRef = /*#__PURE__*/_zoneWrap(fromRef$1, true);
const list = /*#__PURE__*/_zoneWrap(list$1, true);
const listVal = /*#__PURE__*/_zoneWrap(listVal$1, true);
const object = /*#__PURE__*/_zoneWrap(object$1, true);
const objectVal = /*#__PURE__*/_zoneWrap(objectVal$1, true);
const stateChanges = /*#__PURE__*/_zoneWrap(stateChanges$1, true);

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const child = /*#__PURE__*/_zoneWrap(child$1, true, 2);
const connectDatabaseEmulator = /*#__PURE__*/_zoneWrap(connectDatabaseEmulator$1, true);
const enableLogging = /*#__PURE__*/_zoneWrap(enableLogging$1, true);
const endAt = /*#__PURE__*/_zoneWrap(endAt$1, true, 2);
const endBefore = /*#__PURE__*/_zoneWrap(endBefore$1, true, 2);
const equalTo = /*#__PURE__*/_zoneWrap(equalTo$1, true, 2);
const forceLongPolling = /*#__PURE__*/_zoneWrap(forceLongPolling$1, true);
const forceWebSockets = /*#__PURE__*/_zoneWrap(forceWebSockets$1, true);
const get = /*#__PURE__*/_zoneWrap(get$1, true);
const getDatabase = /*#__PURE__*/_zoneWrap(getDatabase$1, true);
const goOffline = /*#__PURE__*/_zoneWrap(goOffline$1, true);
const goOnline = /*#__PURE__*/_zoneWrap(goOnline$1, true);
const increment = /*#__PURE__*/_zoneWrap(increment$1, true, 2);
const limitToFirst = /*#__PURE__*/_zoneWrap(limitToFirst$1, true, 2);
const limitToLast = /*#__PURE__*/_zoneWrap(limitToLast$1, true, 2);
const off = /*#__PURE__*/_zoneWrap(off$1, true);
const onChildAdded = /*#__PURE__*/_zoneWrap(onChildAdded$1, true);
const onChildChanged = /*#__PURE__*/_zoneWrap(onChildChanged$1, true);
const onChildMoved = /*#__PURE__*/_zoneWrap(onChildMoved$1, true);
const onChildRemoved = /*#__PURE__*/_zoneWrap(onChildRemoved$1, true);
const onDisconnect = /*#__PURE__*/_zoneWrap(onDisconnect$1, true);
const onValue = /*#__PURE__*/_zoneWrap(onValue$1, true);
const orderByChild = /*#__PURE__*/_zoneWrap(orderByChild$1, true, 2);
const orderByKey = /*#__PURE__*/_zoneWrap(orderByKey$1, true, 2);
const orderByPriority = /*#__PURE__*/_zoneWrap(orderByPriority$1, true, 2);
const orderByValue = /*#__PURE__*/_zoneWrap(orderByValue$1, true, 2);
const push = /*#__PURE__*/_zoneWrap(push$1, true, 2);
const query = /*#__PURE__*/_zoneWrap(query$1, true, 2);
const ref = /*#__PURE__*/_zoneWrap(ref$1, true, 2);
const refFromURL = /*#__PURE__*/_zoneWrap(refFromURL$1, true, 2);
const remove = /*#__PURE__*/_zoneWrap(remove$1, true, 2);
const runTransaction = /*#__PURE__*/_zoneWrap(runTransaction$1, true);
const set = /*#__PURE__*/_zoneWrap(set$1, true, 2);
const setPriority = /*#__PURE__*/_zoneWrap(setPriority$1, true, 2);
const setWithPriority = /*#__PURE__*/_zoneWrap(setWithPriority$1, true, 2);
const startAfter = /*#__PURE__*/_zoneWrap(startAfter$1, true, 2);
const startAt = /*#__PURE__*/_zoneWrap(startAt$1, true, 2);
const update = /*#__PURE__*/_zoneWrap(update$1, true, 2);

/**
 * Generated bundle index. Do not edit.
 */

export { Database, DatabaseInstances, DatabaseModule, auditTrail, changeToData, child, connectDatabaseEmulator, databaseInstance$, enableLogging, endAt, endBefore, equalTo, forceLongPolling, forceWebSockets, fromRef, get, getDatabase, goOffline, goOnline, increment, limitToFirst, limitToLast, list, listVal, object, objectVal, off, onChildAdded, onChildChanged, onChildMoved, onChildRemoved, onDisconnect, onValue, orderByChild, orderByKey, orderByPriority, orderByValue, provideDatabase, push, query, ref, refFromURL, remove, runTransaction, set, setPriority, setWithPriority, startAfter, startAt, stateChanges, update };
